import { createAsyncThunk } from "@reduxjs/toolkit";
import { type ReferralDetail } from "../../../domain/entities/referral-backoffice";
import { type ReferralsBackofficeDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const linkReferral = createAsyncThunk<
  ReferralDetail,
  { referralId: string; requestId: string },
  { dispatch: ReferralsBackofficeDispatch; extra: ExtraArgument; state: State }
>(
  thunkTypes.LINK_REFERRAL,
  async ({ referralId, requestId }, { extra }) => {
    return await extra.referralsBackofficeRepo.link(
      referralId,
      requestId,
    );
  },
);
